import { render, staticRenderFns } from "./modalUjiKom.vue?vue&type=template&id=637caa46&"
import script from "./modalUjiKom.vue?vue&type=script&lang=js&"
export * from "./modalUjiKom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports